<ng-container *ngIf="contentloaded">
  <idp-stays-widget
    (expandEmit)="expandEmit.emit($event)"
    (errorStateChange)="errorStateChange.emit($event)"
    (openModalEmit)="openModal($event)"
    [locationSelected]="locationSelected"
    [viewSearchOptionExpanded]="viewSearchOptionExpanded"
    [staysWidgetForm]="bookingStaysFacadeService.staysWidgetForm"
    [resetErrors]="resetErrors"
    (formSubmitted)="bookingStaysFacadeService.formSubmitted($event)"
    [content]="
      (bookingStaysFacadeService.staysWidgetContent$ | ngrxPush) ||
      emptyStaysContent
    "
    (analyticsEvent)="handleAnalytics($event)"
  ></idp-stays-widget>
  <idp-airport-dropdown
    *ngIf="isSelected"
    [openModal]="openModalEvent"
    [airportModalContent]="locationModalContent"
    [selectedValue]="locationSelected"
    [searchErrorMessage]="
      bookingStaysFacadeService.airportSearchErrorService.searchErrorMessage
    "
    (airportSelected)="onLocationSelected($event)"
    (searchValueEmit)="searchValue($event)"
    (closeModal)="openModal(false)"
  ></idp-airport-dropdown>
</ng-container>

<div
  *ngIf="!contentloaded && !bookingStaysFacadeService.showAlert"
  id="mach-core-booking-stays-loader"
  class="page-loader"
></div>

<section
  *ngIf="bookingStaysFacadeService.showAlert"
  id="mach-core-booking-stays-alert"
  class="banner-global-header-alert !p-[0] tablet:!p-24"
>
  <div class="banner-main">
    <div class="banner-content">
      <svg class="banner-icon"></svg>
      <label [innerHTML]="noDataErrorMessage"></label>
    </div>
  </div>
</section>
